export default __webpack_public_path__ + "static/media/detail_mobile_13_1.d611ff4a.jpg";